module.exports = __webpack_public_path__ + "static/media/empty-cal.00047e0e.svg";